import { render, staticRenderFns } from "./modal-basics-info.vue?vue&type=template&id=4c7d683e"
import script from "./modal-basics-info.vue?vue&type=script&lang=js"
export * from "./modal-basics-info.vue?vue&type=script&lang=js"
import style0 from "./modal-basics-info.vue?vue&type=style&index=0&id=4c7d683e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports